const futureInstruction = (str) => {
  switch (str) {
    case 'discharge':
      return 'Discharging';
    case 'hold':
      return 'Consuming/solar charge';
    default:
      return 'Charging';
  }
};

export default futureInstruction;
